import { Eye } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RentModel } from 'types/api'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

import RentPayment from './RentPayment'

const RentDetail = ({ rent }: { rent: RentModel }) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation('contract')

  return (
    <>
      <Button
        variant="ghostDark"
        size="icon"
        aria-label={t('rent_table.detail')}
        onClick={() => setOpen(true)}
      >
        <Eye className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>{t('rent_table.detail')}</DialogTitle>
          </DialogHeader>
          <RentPayment rent={rent} embedded />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default RentDetail
